import { Navigate } from 'react-router-dom';
import storage from '../../helpers/storage';
import { useCustomStore } from '../../redux/store';
import { redirectionRoutes } from '../redirectionRoutes';

const AuthGuard: React.FC<{children: React.ReactNode}> = ({ children }: any) => {
    const authToken = storage.getToken();
    const { user } = useCustomStore();
    if (authToken) {
        // if(!user?.profileVerification?.status) {;
        //     return <Navigate to={redirectionRoutes.profile.path} replace />;
        // } else {
            if(user?.fullName && user?.email && user?.mobile && user?.companyName && user?.companyWebsite) {
                return <Navigate to={redirectionRoutes.dashboard.path} replace />;
            } else {
                return <Navigate to={redirectionRoutes.profile.path} replace />;
            }
        // }
    }
    return children
};

export default AuthGuard;